import React, { useState, useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSpring, animated } from '@react-spring/web';
import { ImArrowUpRight } from 'react-icons/im';

const Services = () => {
  const [services, setServices] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  const titleProps = useSpring({
    from: { opacity: 0, transform: 'translateY(-20px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
    config: { duration: 1000 },
  });

  const descriptionProps = useSpring({
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
    delay: 500,
    config: { duration: 1000 },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_GRIPHOLD_API_URL}/api/auth/allmanageservices`);
        if (!response.ok) {
          throw new Error('Failed to fetch services');
        }
        const data = await response.json();
        setServices(data); // Update state with fetched data
      } catch (error) {
        console.error('Error fetching services:', error);
      }
    };

    fetchData();
    window.scrollTo(0, 0);
  }, []);
  const truncateText = (text, limit) => {
    if (text.length > limit) {
      return text.substring(0, limit) + "...";
    }
    return text;
  };
  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="home1-solution-section mb-50">
      <div className="container-lg container-fluid">
      <div class="vector d-lg-flex d-none">
                <svg width="400" height="200" viewBox="0 0 300 372" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g>
                        <circle cx="-20" cy="320" r="270" stroke-width="100"></circle>
                    </g>
                </svg>
            </div>
        <Row className="g-4 mb-30">
          <Col lg={12} md={12}>
            <div className="sub-title text-animation">
              <div className="section-title text-animation custom-color">
                <animated.h2 style={titleProps}>
                  Our <span>Services</span>
               
                 
                </animated.h2>
              </div>
            </div>
          </Col>
          <Col lg={12} md={12}>
            <div className="section-title text-animation">
              <animated.h2 style={titleProps}>
                <h2>
                  Tailored Solutions,
                   <span className='serviceSpan'>Seamless Experiences</span>
                </h2>
              </animated.h2>
            </div>
          </Col>
        </Row>
        <Row className="g-lg-4 gy-5">
        {services.length > 0 &&
        services.map((service, index) => (
          <Col lg={4} md={6} key={index} className={activeIndex === index ? 'active' : ''}>
          <Card className='serviceCard'>
              
                
                 
                    <div className="solution-img serviceImg">
                      <img src={`${process.env.REACT_APP_GRIPHOLD_API_URL}/${service.ServiceImage}`} alt={`Service ${index + 1}`} className='services-img'/>
                    </div>
                    <h6 className="accordion-header accordingNew">
                      <button
                        className={`accordion-button ${activeIndex === index ? '' : 'collapsed'}`}
                        onClick={() => handleToggle(index)}
                        type="button"
                        aria-expanded={activeIndex === index}
                        aria-controls={`flush-collapse-${index}`}
                      >
                        {` ${service.Title}`}
                        
                      </button>
                    </h6>
              
                    <div
                      id={`flush-collapse-${index}`}
                      className={`accordion-collapse collapse ${activeIndex === index ? 'show' : 'show'}`}
                      aria-labelledby={`flush-heading-${index}`}
                      data-bs-parent="#accordionFlushExample"
                    >
                     <div className="accordion-body" style={{height:"160px" ,overflow:"hidden"}}>
                        <div dangerouslySetInnerHTML={{ __html: service.Description }} />
                        
                      </div>
                    </div>
                    <Link className="explore-btn exploreLink" to={`/services/${service.Title}`}>
                          Explore More
                         
                          <ImArrowUpRight />
                        </Link>
                    </Card>
          </Col>
            ))}
          
        </Row>
      </div>
    </div>
  );
};

export default Services;
